import { MDText } from 'i18n-react';

import AnnabelAvif from '../../../../../../client/assets_seller/homepage/stories/annabel.avif';
import AnnabelJpg from '../../../../../../client/assets_seller/homepage/stories/annabel.jpg';
import AnnabelWebp from '../../../../../../client/assets_seller/homepage/stories/annabel.webp';
import AnnabelAvifSmall from '../../../../../../client/assets_seller/homepage/stories/annabel_s.avif';
import AnthoniaAvif from '../../../../../../client/assets_seller/homepage/stories/anthonia.avif';
import AnthoniaJpg from '../../../../../../client/assets_seller/homepage/stories/anthonia.jpg';
import AnthoniaWebp from '../../../../../../client/assets_seller/homepage/stories/anthonia.webp';
import AnthoniaAvifSmall from '../../../../../../client/assets_seller/homepage/stories/anthonia_s.avif';
import NigelAvif from '../../../../../../client/assets_seller/homepage/stories/nigel.avif';
import NigelJpg from '../../../../../../client/assets_seller/homepage/stories/nigel.jpg';
import NigelWebp from '../../../../../../client/assets_seller/homepage/stories/nigel.webp';
import NigelAvifSmall from '../../../../../../client/assets_seller/homepage/stories/nigel_s.avif';

import SellerStoriesTexts from './SellerStories.texts.json';

const LocalT = new MDText(SellerStoriesTexts);
const t = (key: string, props?: { [key:string]: unknown }) => LocalT.translate(key, props) as string;

export const sellerStoriesConfig = {
  highlightedWord: t('highlightedWord'),
  label: t('label'),
  stories: [
    {
      details: t('stories.0.details'),
      image: {
        avif: [AnthoniaAvifSmall, AnthoniaAvif],
        png: AnthoniaJpg,
        webp: AnthoniaWebp,
      },
      label: t('label'),
      quote: t('stories.0.quote'),
    },
    {
      details: t('stories.1.details'),
      image: {
        avif: [NigelAvifSmall, NigelAvif],
        png: NigelJpg,
        webp: NigelWebp,
      },
      label: t('label'),
      quote: t('stories.1.quote'),
    },
    {
      details: t('stories.2.details'),
      image: {
        avif: [AnnabelAvifSmall, AnnabelAvif],
        png: AnnabelJpg,
        webp: AnnabelWebp,
      },
      label: t('label'),
      quote: t('stories.2.quote'),
    },
  ],
  subtitle: t('subtitle'),
  title: t('title'),
};
